module.exports = __webpack_public_path__ + "static/il-chart-89da2ee3e42e3f3d5bba55101d02484c.svg";